module.exports = __webpack_public_path__ + "assets/logo_dtcc.958598ee.svg";